import * as React from "react";
import { storyblokEditable } from "gatsby-source-storyblok";
import { Href } from "../utils/helper";

const AdCard = ({ blok }) => {

  return (
    <div className={`h-[500px] md:h-auto md:max-h-max border rounded-lg hover:scale-105 hover:shadow-md transition ${blok.doubleWidth ? 'md:col-span-2' : ''}`} {...storyblokEditable(blok)}>
      <a href={Href(blok.ctaUrl)} className="">
        <img className="w-full h-full object-cover items-center rounded" loading="lazy" src={`${blok.image?.filename}/m/`} alt={blok.image?.alt} />
      </a>
    </div>
  );
};

export default AdCard;